import { Link } from 'react-router-dom';
import { dramas } from '@/mocks/dramas';

export default function HeroSection() {
  const featured = dramas.filter((d) => d.featured).slice(0, 5);

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20movie%20theater%20interior%20with%20velvet%20curtains%20and%20warm%20golden%20stage%20lights%2C%20elegant%20and%20mysterious%20atmosphere%2C%20rich%20dark%20red%20and%20gold%20accents%2C%20film%20projector%20beam%20cutting%20through%20darkness%2C%20artistic%20abstract%20composition%2C%20luxurious%20cinema%20aesthetic&width=1920&height=1080&seq=hero-bg-6080&orientation=landscape"
          alt="6080影视 - 电视剧全集免费在线观看"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1400px] mx-auto flex flex-col items-center text-center pt-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 mb-4 leading-tight">
          电视剧全集
          <span className="text-primary-500"> 免费高清 </span>
          在线观看
        </h1>
        <p className="text-sm md:text-base text-foreground-300 max-w-2xl mb-8 leading-relaxed">
          高清不缓冲 · 超清画质 · 海量免费电视剧每日更新 · 热门经典随心看
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 mb-12">
          <Link
            to="/category/guochan"
            className="px-6 py-3 bg-primary-500 text-background-950 font-medium rounded-full text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>开始追剧
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 border border-foreground-300/30 text-foreground-200 font-medium rounded-full text-sm hover:bg-foreground-100/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="hidden md:grid grid-cols-5 gap-3 w-full max-w-5xl">
          {featured.map((drama, i) => (
            <Link
              key={drama.id}
              to={`/article/${drama.id}`}
              className="group relative rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 hover:z-10"
              style={{ aspectRatio: '2/3' }}
            >
              <img
                src={drama.cover}
                alt={drama.title}
                className="w-full h-full object-cover"
                loading={i > 2 ? 'lazy' : undefined}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <p className="text-xs text-foreground-200 font-medium truncate">{drama.title}</p>
                <p className="text-xs text-primary-500 mt-0.5">{drama.rating}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}